import { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { getState, updateState } from '../lib/onboardingApi'

const OnboardingContext = createContext(null)

const EMPTY = {
  welcome_shown: false,
  rail_collapsed: false,
  skipped_steps: [],
  prefetch_url: null,
  persona: null,
  completed_at: null,
  steps: { mailbox: false, dns: false, warmup: false, contacts: false, campaign: false },
}

export function OnboardingProvider({ children }) {
  const [state, setState] = useState(EMPTY)
  const [loaded, setLoaded] = useState(false)

  const refresh = useCallback(async () => {
    try {
      const s = await getState()
      setState(s)
    } catch (e) {
      // silent: rail hides on failure (per spec §7)
    } finally {
      setLoaded(true)
    }
  }, [])

  const patch = useCallback(async (p) => {
    try {
      const s = await updateState(p)
      setState(s)
    } catch (e) {
      // toast handled by caller if needed
    }
  }, [])

  useEffect(() => { refresh() }, [refresh])

  const progress = Object.values(state.steps).filter(Boolean).length
  const total = 5
  const done = state.completed_at != null
  const visible = loaded && !done

  return (
    <OnboardingContext.Provider value={{ state, progress, total, done, visible, refresh, patch }}>
      {children}
    </OnboardingContext.Provider>
  )
}

export function useOnboarding() {
  const ctx = useContext(OnboardingContext)
  if (!ctx) throw new Error('useOnboarding must be used inside OnboardingProvider')
  return ctx
}
